<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Experience(s)</h4>
    </div>
    <v-row
      v-for="(item, i) in experience_list"
      :key="i"
    >
      <v-col cols="12">
        <v-row>
          <v-col
            md="2"
            cols="4"
          >
            Experience detail:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ experience_list[i].detail || '-' }} ({{ experience_list[i].experience_month }} month(s))
          </v-col>
          <v-col
            md="2"
            cols="4"
          >
            Location:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ experience_list[i].location || '-' }}
          </v-col>
          <v-col
            md="2"
            cols="4"
          >
            Start date:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ experience_list[i].start_date || '-' }}
          </v-col>
          <v-col
            md="2"
            cols="4"
          >
            End date:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ experience_list[i].end_date || '-' }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'SupporterExperience',
  props: ['experience_list', 'remove_experience'],
  methods: {
    addExperience () {
      this.experience_list.push({ detail: '', location: '', month: '', start_date: '', end_date: '' })
    },
    removeExperience (index) {
      if (this.experience_list[index].id)
        this.remove_experience.push(this.experience_list[index].id)
      this.experience_list.splice(index, 1)
    }
  },
}
</script>